import ActionsForm from '@/shared/mixins/actionsForm'
import EnterpriseRepository from '@/shared/http/repositories/realestate/enterprise'
import AutocompleteZ from '@/components/forms/AutocompleteZ'
import ExpenseMixin from '@/views/private/finance/expenses/travelexpenses/mixins/ExpenseMixin.js'
import localStoreHelper from '@/shared/utils/localStoreHelper.js'
export default {
  mixins: [ActionsForm, ExpenseMixin],
  components: {
    AutocompleteZ
  },
  name: 'formPrice',
  data () {
    return {
      title: 'Buscar Tabela de Preço',
      consultaenterprise: [],
      consultastate: [],
      SearchItems: {
        cidadeObj: {
          value: null,
          options: [],
          required: false,
          state: null,
          code: null
        },
        empreendimentoId: '',
        CidadeId: '',
        cidade: '',
        UF: '',
        DataInicio: '',
        DataFinal: ''
      }
    }
  },
  mounted () {
    this.GetAllEnterprise()
    this.GetAllState()
    this.GetCityByName()
  },
  methods: {
    edit () {
      this.flDetails = true
    },
    GetAllEnterprise () {
      EnterpriseRepository.GetEnterprisesFilter()
        .then(Response => {
          this.consultaenterprise = Response.data.data
        })
        .catch(() => {})
    },
    GetAllState () {
      EnterpriseRepository.GetStatesFilter()
        .then(Response => {
          this.consultastate = Response.data.data
        })
        .catch(() => {})
    },
    GetCityByName () {
      EnterpriseRepository.GetCityByNameEnterprise()
        .then(Response => {
          this.cidadeObj = Response.data.data
        })
        .catch(() => {})
    },
    Clear () {
      this.$refs.CityEnterpriseTypeahead.clear()
      Object.keys(this.SearchItems).forEach(prop => {
        if (prop === 'cidadeObj') {
          this.SearchItems[prop].value = null
        } else {
          this.SearchItems[prop] = ''
        }
      })
      this.SearchItems.CidadeId = ''
      localStoreHelper.gestao.tabelaPreco(null)
      this.$emit('SearchItems', this.SearchItems)
      // EnterpriseRepository.GetEmpreendimentoByFiltro(this.SearchItems)
      //   .then(res => {
      //     if (res.status === 200) {
      //       let newRequestsArray = res.data.data
      //       let newResponse = res
      //       this.$emit('SearchItems', newRequestsArray, newResponse)
      //     }
      //   })
      //   .catch(() => {})
    },
    Search () {
      this.SearchItems.CidadeId = this.SearchItems.cidadeObj == null ? undefined : this.SearchItems.cidadeObj.value
      this.$emit('SearchItems', this.SearchItems)
      localStoreHelper.gestao.tabelaPreco({empreendimentoId: this.SearchItems.empreendimentoId, CidadeId: this.SearchItems.cidadeObj.value, UF: this.SearchItems.estadoId, DataInicio: this.SearchItems.DataCadastroInicio, DataFinal: this.SearchItems.DataCadastroFim})

      // EnterpriseRepository.GetEmpreendimentoByFiltro(this.SearchItems)
      //   .then(res => {
      //     if (res.status === 200) {
      //       let newRequestsArray = res.data.data
      //       let newResponse = res
      //       this.$emit('SearchItems', newRequestsArray, newResponse)
      //     }
      //   })
      //   .catch(() => {})
    }
  }
}



// WEBPACK FOOTER //
// ./src/views/private/realestate/pricetablemanagement/components/formPrice/formPrice.js